import { jsxs as l, jsx as t, Fragment as D } from "react/jsx-runtime";
import { Icon as p } from "../../../../../components/Icon/index.js";
import { DealStatus as E, DealAction as u } from "../../../../../types/Deal/index.js";
import { Container as k, LeftActionsContainer as I, VoteButton as $, CommentButton as B, ShareButton as T, SeeDealButton as C, SeeDealMobileText as _, SeeDealBigScreenText as g } from "./style.js";
import { Message as j, ChevronRight as K } from "@pelando/fontawesome/icons";
import { useTranslation as L } from "../../../../../hooks/useTranslation/index.js";
const z = ({
  voteInfo: h,
  deal: f,
  commentsDealUrl: d,
  isFixedCard: o,
  fixedCardButtonText: s,
  isOnboardingCard: e,
  locale: S,
  actionHandler: a,
  keepMobileLayout: n = !1
}) => {
  const { t: m } = L("common"), { id: c, temperature: v, commentCount: r, status: y } = f, i = y !== E.ACTIVE, A = !o;
  return /* @__PURE__ */ l(k, { $hasAnimation: e, children: [
    /* @__PURE__ */ l(I, { $hasAnimation: e, children: [
      /* @__PURE__ */ t(
        $,
        {
          id: c,
          temperature: v,
          voteInfo: h,
          dispatch: a,
          inactive: i,
          isOnboardingCard: e,
          $keepMobileLayout: n
        }
      ),
      o ? null : /* @__PURE__ */ l(D, { children: [
        /* @__PURE__ */ l(
          B,
          {
            light: !0,
            title: `${r} ${m("deal-feed-card-actions-comment-button")}`,
            onClick: () => a({
              type: u.CLICK_COMMENTS,
              payload: { id: c }
            }),
            url: d,
            inactive: i,
            style: {
              cursor: e ? "default" : "pointer",
              pointerEvents: e ? "none" : "all"
            },
            "data-keep-mobile-layout": n,
            children: [
              /* @__PURE__ */ t(p, { icon: j }),
              r.toString()
            ]
          }
        ),
        /* @__PURE__ */ t(
          T,
          {
            id: c,
            dispatch: a,
            isInactive: i,
            locale: S
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ l(
      C,
      {
        light: A,
        isFixedCard: o,
        onClick: () => a({
          type: u.CLICK_SEE_DEAL,
          payload: { id: c }
        }),
        inactive: i,
        "data-testid": "see-deal-link",
        style: {
          cursor: e ? "default" : "pointer",
          pointerEvents: e ? "none" : "all"
        },
        "data-keep-mobile-layout": n,
        children: [
          /* @__PURE__ */ t(_, { "data-keep-mobile-layout": n, children: o ? s : m("deal-feed-card-actions-see-deal-mobile") }),
          /* @__PURE__ */ t(g, { "data-keep-mobile-layout": n, children: o ? s : m("deal-feed-card-actions-see-deal-desktop") }),
          /* @__PURE__ */ t(p, { icon: K })
        ]
      }
    )
  ] });
};
export {
  z as DealFeedCardActions
};
